/**
 * Full-width band across the top of a planning board card that is an interventie.
 *
 * The board already spends every pastel hue on project colours and uses small
 * pills for status and crew, so a pill or a tint cannot mark a repair at first
 * look. A solid band can: nothing else on the board is a full-width solid bar.
 * The band form won a blind design review of the whole week board (2026-09-29);
 * Igor then chose orange for it — solid orange-600, well apart from the pale
 * amber status chip and peach crew pill.
 *
 * Sits inside the card's padding box (negative margins cancel `p-1.5`), so the
 * project colour stripe on the left edge stays intact.
 */
export function InterventieBand() {
  return (
    <div
      title="Interventie"
      className="-mx-1.5 -mt-1.5 mb-1 rounded-tr bg-orange-600 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white"
    >
      Interventie
    </div>
  );
}
